import React, { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import Zoom from "react-medium-image-zoom";
import "react-image-gallery/styles/image-gallery.css";
import "react-medium-image-zoom/dist/styles.css";

import DownloadAllFilesDirecty from "../../../../Common/FilesRelevent/DownloadAllFilesDirecty";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { preprocessImages } from "../../../../../utils/preprocessImagespath";

export default function ReactImageGalleryCompoment({ images = [] }) {
  const [processedImages, setProcessedImages] = useState([]);

  useEffect(() => {
    if (images?.length) {
      preprocessImages(images).then(setProcessedImages);
    }
  }, [images]);

  const renderItem = (item) => (
    <div
      className="image-gallery-image-container"
      style={{ position: "relative" }}
    >
      {/* ZOOM IMAGE */}
      <Zoom>
        <img
          src={item.original}
          alt=""
          className="image-gallery-image"
          style={{
            width: "100%",
            cursor: "zoom-in",
          }}
        />
      </Zoom>

      {/* DOWNLOAD BUTTON */}
      <button
        onClick={() => DownloadAllFilesDirecty(item.file_url)}
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          background: "rgba(255,255,255,0.85)",
          border: "none",
          padding: "8px",
          borderRadius: "4px",
          cursor: "pointer",
          zIndex: 5,
        }}
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/download-icon-black.png`}
          alt="Download"
          style={{ width: "20px", height: "20px" }}
        />
      </button>
    </div>
  );

  return (
    <ReactImageGallery
      className="w-100 big-image"
      items={processedImages}
      renderItem={renderItem}
      showPlayButton={false}
      showFullscreenButton={false}
      showBullets={false}
      showNav={true}
    />
  );
}
